import Swiper from 'swiper'

class PartnerSwiper {
  constructor (wrapper) {
    this.container = wrapper.querySelector('.js-swiper-container')
    this.pause = {
      button: wrapper.querySelector('.js-swiper-pause'),
      text: wrapper.querySelector('.js-swiper-pause-text')
    }
    this.isPaused = false

    this.swiper = new Swiper(this.container, {
      a11y: {
        firstSlideMessage: 'Erster Partner',
        lastSlideMessage: 'Letzter Partner',
        nextSlideMessage: 'Nächster Partner',
        prevSlideMessage: 'Vorheriger Partner'
      },
      autoplay: {
        delay: 5000
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 16
        },
        992: {
          slidesPerView: 2
        }
      },
      loop: true,
      slidesPerView: 3,
      spaceBetween: 32
    })

    this.container.addEventListener('mouseover', () => {
      if (!this.isPaused) {
        this.stop()
      }
    })

    this.container.addEventListener('mouseout', () => {
      if (!this.isPaused) {
        this.start()
      }
    })

    this.pause.button.addEventListener('click', () => {
      if (this.swiper.autoplay.running) {
        this.stop()
        this.isPaused = true
      } else {
        this.start()
        this.isPaused = false
      }
    })
  }

  stop () {
    this.swiper.autoplay.stop()
    this.pause.button.classList.remove('is-playing')
    this.pause.text.innerText = 'Bild starten'
  }

  start () {
    this.swiper.autoplay.start()
    this.pause.button.classList.add('is-playing')
    this.pause.text.innerText = 'Bild anhalten'
  }
}

// Initialize all swipers

let wrappers = document.querySelectorAll('.js-swiper-wrapper')

/**
 * This slightly obscure contruct is necessary because:
 * - On page load an accordion is collapsed
 * - This confuses Swiper and therefore the slider is broken
 * - The solution is to wait with the Swiper intialization
 */
for (let i = 0; i < wrappers.length; i++) {
  const panel = jQuery(wrappers[i]).closest('.panel')

  if (panel.length) {
    panel.on('shown.bs.collapse', () => new PartnerSwiper(wrappers[i]))
  } else {
    // eslint-disable-next-line no-new
    new PartnerSwiper(wrappers[i])
  }
}



// WEBPACK FOOTER //
// ./src/components/partner/scripts.js